/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationTrendRequest {
    getFixupPrototypeFunction() { return CostOptimizationTrendRequest.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationTrendRequest>): CostOptimizationTrendRequest {
        let obj = Object.assign(new CostOptimizationTrendRequest(), model);
        CostOptimizationTrendRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationTrendRequest>): CostOptimizationTrendRequest {
        if (!model) return null;
        return CostOptimizationTrendRequest.newInstance(<CostOptimizationTrendRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationTrendRequest) {
        if (!obj) return;

        models.CostOptimizationTrendRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationTrendRequest): boolean {
        Object.setPrototypeOf(obj, CostOptimizationTrendRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filter) {
            models.AccountFilters.fixupPrototype(this.filter);
        }
    }

    filter: models.AccountFilters;

    /**
     * currency of the cost. Example 'currency':'USD'
     */
    currency: models.Currency;

}
